export default __webpack_public_path__ + "assets/umbrella.2c29f38f.svg";